import ApiService from '../_shared/api/apiService';
import Singleton from '../Singleton';

export default class TradeService extends Singleton<TradeService> {
  /**
   * Public Methods
   */
  public getTradeDetails = async (tradeId: number) => {
    const client = await ApiService();
    let tradeDetailsResponse;

    try {
      tradeDetailsResponse = await client.apis.trade.getTrade({
        id: tradeId,
        request: {
          request: {}
        }
      });
    } catch (e) {
      throw new Error(e);
    }
    return tradeDetailsResponse?.body;
  };

  public getTradeState = async (tradeId: number) => {
    try {
      const client = await ApiService();
      const tradeDetailsResponse = await client.apis.trade.getTrade({
        id: tradeId,
        request: {
          request: { returnOnly: ['tradeState'] }
        }
      });
      return tradeDetailsResponse?.body?.tradeState;
    } catch (e) {
      // TODO handle exception
      return null;
    }
  };

  public getAssociatedTradeDetails = async (
    tradeId: number,
    returnOnly: string[]
  ) => {
    try {
      const client = await ApiService();
      const tradeDetailsResponse = await client.apis.trade.getTrade({
        id: tradeId,
        request: {
          request: { returnOnly }
        }
      });
      return tradeDetailsResponse?.body;
    } catch (e) {
      // TODO handle exception
      return null;
    }
  };

  public getAssociatedTradeState = async openNetworkAssociatedTradeId => {
    if (openNetworkAssociatedTradeId) {
      return this.getTradeState(openNetworkAssociatedTradeId)
        .then(currentTradeState => currentTradeState)
        .catch(e => null);
    }
    return null;
  };

  public decodeVin = async ({ vin }) => {
    const client = await ApiService();

    if (vin) {
      try {
        const decodedResponse = await client.apis.trade.decode({
          request: {
            request: {
              vin
            }
          }
        });

        const { bestTrimName, details } = decodedResponse.body?.trade;
        const { modelYear, model } = details.tradeVehicleSummary.vehicleSummary;
        const { manufacturerName, displayName } = model;

        return {
          decodedYear: modelYear,
          decodedMake: manufacturerName,
          decodedModel: displayName,
          decodedBestTrimName: bestTrimName
        };
      } catch (e) {
        return e;
      }
    }
    return null;
  };
}
